import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { IPagedResults } from 'src/app/core/models/base';
import { environment } from 'src/environments/environment';
import { ICreateUserRequest, IEmployee, IGetEmployeesRequest, IUpdateUserRequest } from '../models/employee';

@Injectable({
  providedIn: 'root'
})
export class EmployeeService {

  constructor(private http: HttpClient) { }


  public getEmployees(request: IGetEmployeesRequest){
    return this.http.post<IPagedResults<IEmployee[]>>(
      `${environment.baseUrl}/v1/employees/getEmployees`,
      request
    )
  }

  public getHtecEmployees(){
    return this.http.get<IPagedResults<IEmployee[]>>(
      `${environment.baseUrl}/v1/employees/getHtecEmployees`
    )
  }

  public getEmployeeById(id: string){
    return this.http.get<IEmployee>(
      `${environment.baseUrl}/v1/employees/getEmployee/${id}`
    )
  }

  public getCurrentEmployee(){
    return this.http.get<IEmployee>(
      `${environment.baseUrl}/v1/employees/getEmployeeDetails`
    )
  }

  public createEmployee(request : ICreateUserRequest){
    return this.http.post<IEmployee>(
      `${environment.baseUrl}/v1/employees/createEmployee`,
      request
    )
  }

  public updateEmployee(request: IUpdateUserRequest){
    return this.http.put<IEmployee>(
      `${environment.baseUrl}/v1/employees/updateEmployee/${request.id}`,
      request
    )
  }

  public deleteEmployee(id: string){
    return this.http.delete<string>(
      `${environment.baseUrl}/v1/employees/deleteEmployee/${id}`
    )
  }
}
